import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import GradeScaleForm from 'components/organisms/forms/GradeScaleForm'

import { crudActionsMap } from 'utils/helpers'

const GradeScaleCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('school.grading-scale')} / ${t('common.' + action)}`} />
      <PageBody>
        <GradeScaleForm action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default GradeScaleCrudPage
